var map = {
	"./sticker_outline_number_0.png": 4527,
	"./sticker_outline_number_1.png": 5522,
	"./sticker_outline_number_2.png": 4971,
	"./sticker_outline_number_3.png": 2342,
	"./sticker_outline_number_4.png": 6622,
	"./sticker_outline_number_5.png": 5650,
	"./sticker_outline_number_6.png": 259,
	"./sticker_outline_number_7.png": 2573,
	"./sticker_outline_number_8.png": 8925,
	"./sticker_outline_number_9.png": 947
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2506;